import type { ComponentTheme } from '../types/component-theme';

import { LayoutVariants } from './constants/layout-variants';

export default {
    slots: {
        description: 'm-0 mb-5 font-(family-name:--primary-font) text-[1rem] leading-[1.65] text-(--text-light)',

        form: 'mb-2 gap-[1.2rem]',

        field: 'mb-[1.2rem] min-w-0 flex-1',

        input: 'w-full min-w-0',

        inputBase: 'min-w-0 overflow-hidden text-ellipsis whitespace-nowrap ps-23!',

        inputLeading: 'pointer-events-auto inset-s-0 w-20 justify-start ps-4',

        inputUnit:
            'block overflow-hidden text-ellipsis whitespace-nowrap rounded-[0.45rem] border ' +
            'border-[rgba(148,163,184,0.14)] bg-[rgba(148,163,184,0.08)] px-2.5 py-[0.22rem] text-center select-none ' +
            'font-(family-name:--primary-font) text-[0.63rem] font-semibold uppercase tracking-[0.04em] ' +
            'text-(--text-light)',

        cards: 'grid grid-cols-1 gap-3',

        inputError:
            'border-(--danger-soft-alpha-65) focus-within:border-(--danger-soft-alpha-75) focus-within:outline-none ' +
            'focus-within:shadow-(--danger-soft-focus-shadow) aria-expanded:border-(--danger-soft-alpha-75) ' +
            'aria-expanded:shadow-(--danger-soft-focus-shadow)'
    },

    variants: {
        variant: {
            [LayoutVariants.Default]: {
                form: 'grid grid-cols-1 grid-rows-[auto] sm:grid-cols-[1fr_2fr]',
                cards: 'md:grid-cols-2'
            },

            [LayoutVariants.Column]: {
                form: 'flex flex-col',
                cards: 'grid-cols-1'
            }
        }
    }
} satisfies ComponentTheme;
